import * as React from 'react';

import { cn } from '../../../lib/utils';
import { TextCell } from './text-cell';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface MeasurementCellProps {
  className?: string;
  fallback?: string;
  unit?: string;
  value?: number | string;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Cell component for displaying a numeric measurement with an optional unit.
 * Shows a fallback em-dash when the value is null or undefined.
 * Replaces inline `{value} {unit}` patterns in vehicle-templates and handling-unit-types tables.
 */
export function MeasurementCell({ className, fallback = '—', unit, value }: MeasurementCellProps): React.JSX.Element {
  if (value == null) {
    return <TextCell>{fallback}</TextCell>;
  }

  return (
    <span className={cn('text-sm text-muted-foreground', className)}>
      {value}
      {unit ? ` ${unit}` : ''}
    </span>
  );
}
